<template>

<div class="auth-container">
  
  <div class="auth-image">
    <img class="landing" src="../../assets/landing.svg" />
  </div>

  <div class="auth-form-container">
    <login v-if="isSignIn" 
      :loginSsoGoogle="loginSsoGoogle" 
      :switchAuthView="switchAuthView"/>
    <register v-else
      :loginSsoGoogle="loginSsoGoogle" 
      :switchAuthView="switchAuthView" />

    <reset />
    <registersuccessmodal />
  </div>
      
</div>
    
</template>
<script>
import router from './../../router/router'
import Login from './../authentication/Login'
import Reset from './../authentication/ResetPassword'
import Register from './../authentication/Register'
import RegisterSuccessModal from './../authentication/RegisterSuccessModal'

import Logo from './../home/Logo'
import { mapGetters } from 'vuex'
import GAuth from 'vue-google-oauth2'
import Vue from 'vue'

// TODO oznaka#oidc
const gauthOption = {
  clientId: '220374129611-iki8nu86162jbodvq801tdod4jgn6h0g.apps.googleusercontent.com',
  scope: 'profile email openid',
  prompt: 'select_account'
}
Vue.use(GAuth, gauthOption)

export default {
  name: 'home',
  components: {
    login: Login,
    register: Register,
    registersuccessmodal: RegisterSuccessModal,
    reset: Reset,
    logo: Logo
  },
  data () {
    return {
      isSignIn: true
    }
  },
  computed: {
    ...mapGetters({
      jeAdmin: 'hasAdminRole'
    })
  },
  methods: {
    loginSsoGoogle () {
      this.$gAuth
      .getAuthCode()
      .then(authCode => {
        this.$store.dispatch('loginGoogle', {
          authorization_code: authCode
        }).then(() => {
          router.push({name: this.jeAdmin ? 'adminGroups' : 'groupList'})
          this.$store.dispatch('updateLanguage', localStorage.getItem('language'))
          .then(() => {})
          .catch(() => {
            console.log('Error in login!')
          })
        }).catch((err) => {
          console.log(err)
        })
      })
      .catch(error => {
        console.log('Error in login! ', error)
      })
    },
    switchAuthView (screen) {
      this.isSignIn = screen === 'login'
    }
  }
}
</script>

<style lang="scss">
  /* Auth styles */
  @import '../../assets/k6styles/auth.scss';
</style>

<style scoped>

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}

.nav-tabs > li, .nav-pills > li {
  float:none;
  display:inline-block;
  *display:inline; /* ie7 fix */
   zoom:1; /* hasLayout ie7 trigger */
}

.nav-tabs {
  text-align:center;
}

img {
    display: block;
    margin-left: auto;
    margin-right: auto;
}

</style>



// WEBPACK FOOTER //
// Home.vue?41fd3f0e